import React from 'react';
import { Search, X } from 'lucide-react';

/**
 * SearchInput - Campo de búsqueda consistente
 * 
 * @param {string} value - Valor actual
 * @param {function} onChange - Función al cambiar
 * @param {string} placeholder - Placeholder del input
 * @param {function} onClear - Función para limpiar (opcional)
 * @param {boolean} loading - Estado de carga
 */
export const SearchInput = ({
  value,
  onChange,
  placeholder = 'Buscar...',
  onClear,
  loading = false,
  className = ''
}) => {
  const handleClear = () => {
    if (onClear) {
      onClear();
    } else {
      onChange({ target: { value: '' } });
    }
  };

  return (
    <div className={`relative ${className}`}>
      <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
      <input
        type="text"
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        className="w-full pl-10 pr-10 py-2.5 bg-white border border-slate-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-slate-900/10 focus:border-slate-300 transition-all"
        data-testid="search-input"
      />
      {value && (
        <button
          onClick={handleClear}
          className="absolute right-3 top-1/2 -translate-y-1/2 p-1 hover:bg-slate-100 rounded-full transition-colors"
          data-testid="search-clear"
        >
          <X className="w-3.5 h-3.5 text-slate-400" />
        </button>
      )}
      {loading && (
        <div className="absolute right-3 top-1/2 -translate-y-1/2">
          <div className="w-4 h-4 border-2 border-slate-300 border-t-slate-600 rounded-full animate-spin" />
        </div>
      )}
    </div>
  );
};

export default SearchInput;
